import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RxFormBuilder, RxFormGroup, time } from '@rxweb/reactive-form-validators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Template } from 'src/app/modules/templates/_types/template';
import { environment } from 'src/environment/environment';
import { CaseNotificationNumber } from '../../_types/case-notification-number';
import { Case } from '../../_types/case';
import { CasesNotificationsNumbersService } from '../../_services/cases-notifications-numbers.service';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom, timeout } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { MessageService } from 'primeng/api';
import { evaluateFormula } from 'src/app/core/arithmetic-formula';

@Component({
    selector: 'app-select-template',
    templateUrl: './select-template.component.html',
    styleUrls: ['./select-template.component.scss'],
    standalone: false
})
export class SelectTemplateComponent {
  public formGroup: FormGroup;

  //private endpoint:string = environment.api_gw + 'attendance/caseServices';
 // private caseServiceId: string = "";
  public templateId: string = "";
  //public templatesContracts: [] = [];
  public templates: any = [];
  public message: string = "";
  public selectedTemplate:Template | null = null;
  public metadata: any = {type: "pdf"};
  public notificationNumbers:any[] = [];
  public notificationNumberId: string = '-';

  constructor(
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private formBuilder: RxFormBuilder,
    private caseNotificationNumbersService: CasesNotificationsNumbersService,
    private messageService:MessageService
  ) {
    this.formGroup = this.formBuilder.group({templateId: [""]});    
  }

  async ngOnInit() {
    this.templates = this.config.data.templates;
    this.message = this.config.data.message;
    if(this.config.data.caseId) this.loadNotificationNumbers();
    if(this.templates!=undefined && this.templates!=null && this.templates.length == 1) {
     setTimeout(() => {
      //this.onTemplateChange({value: this.templates[0].id});
      this.templateId = this.templates[0].id;
      this.formGroup.get("templateId")?.setValue(this.templates[0].id);
     },100)
      
    }
  }

  async loadNotificationNumbers() {
    let filter: any = {
      caseId: new Filter(FilterOperation.equals, 'caseId', '', this.config.data.caseId)
    };
    let params: any = {
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.caseNotificationNumbersService.all(params));
    this.notificationNumbers = response.data.map((n: CaseNotificationNumber) => {
      return { id: n.id, code: n.code };
    });
    if(this.notificationNumbers.length == 1){
      this.notificationNumberId = this.notificationNumbers[0].id;
    }
    //añadimos la opcion de no registrado
    this.notificationNumbers.unshift({id: '-', code: 'No registrado'});
  }

  async open(type: string = "pdf") {
    this.metadata['type'] = type;
    
    //comprobamos si hay field notification_number, si lo hay es obligatorio rellenarlos
    if (this.selectedTemplate?.templateConfig?.fields) {
      let notificationNumberField = this.selectedTemplate.templateConfig.fields.find((field: any) => field.name === 'notification_number');
      if (notificationNumberField && (!this.metadata['notification_number'] || this.metadata['notification_number'].trim() == '')) {
        this.messageService.add({severity:'error', summary:'Error', detail:'Debe indicar un número de servicio.'});
        return;
      }
    }
    //devolvemos plantilla escogida y metadada
    let templateId = this.formGroup?.get("templateId")?.value;
    let result:any = {
      templateId: templateId,
      metadata: this.metadata,
      type: type
    }
    this.dynamicDialogRef.close(result);
  }

  async onTemplateChange(event: any) {
    this.templateId = event.value;
    let template = this.templates.find((t: Template) => t.id === this.templateId) || null;
    this.metadata = {};
    if (template?.templateConfig?.fields) {
      for (let field of template.templateConfig.fields) {
        if (field.type === 'boolean') {
          //los booleanos viajan como true/false para poder gobernar un if: en el Word
          this.metadata[field.name] = field.value === true || field.value === 'true';
        } else {
          this.metadata[field.name] = field.value;
        }
      }
      //calculamos los campos con fórmula a partir de los valores iniciales
      this.recomputeFunctions(template.templateConfig.fields);
    }
    this.selectedTemplate = template;

    //si hay servicio elegido lo establecemos en metadata
    if (this.notificationNumberId && this.selectedTemplate?.templateConfig?.fields) {
      let notificationNumberField = this.selectedTemplate.templateConfig.fields.find((field: any) => field.name === 'notification_number');
      let notificationNumber = this.notificationNumbers.find(n => n.id === this.notificationNumberId) || null;
      if (notificationNumber && notificationNumberField) {
        this.metadata['notification_number'] = notificationNumber.code;
      }
    }
  }

  async onSelectNotificationNumber(event: any) {
    this.notificationNumberId = event.value;
    let notificationNumber = this.notificationNumbers.find(n => n.id === this.notificationNumberId) || null;
    if (notificationNumber && this.notificationNumberId != '-') {
      this.metadata['notification_number'] = notificationNumber.code;
    } else {
      this.metadata['notification_number'] = '';
    }
  }

  //un campo es de solo lectura si lo pide la config o si es calculado
  isFieldDisabled(field: any): boolean {
    return field?.disabled === true || !!field?.function;
  }

  //convierte el valor de un input a número aceptando la coma como separador decimal (es-ES)
  private parseNumber(value: any): number {
    if (typeof value === 'number') return value;
    if (value === null || value === undefined || value === '') return NaN;
    return Number(value.toString().trim().replace(',', '.'));
  }

  //recalcula todos los campos con fórmula a partir de los valores actuales de metadata.
  //se llama al cambiar cualquier input editable y al elegir plantilla.
  recomputeFunctions(fields: any[] = this.selectedTemplate?.templateConfig?.fields) {
    if (!fields) return;
    let variables: Record<string, number> = {};
    for (let field of fields) {
      variables[field.name] = this.parseNumber(this.metadata[field.name]);
    }
    for (let field of fields) {
      if (!field.function) continue;
      //si ningún campo referenciado por la fórmula tiene valor, no se pinta nada:
      //un total de 0 por falta de datos no debe salir como "0,00€"
      let referenced: string[] = field.function.match(/[A-Za-z_]\w*/g) || [];
      let hasAnyValue = referenced.some((name: string) => !isNaN(this.parseNumber(this.metadata[name])));
      if (!hasAnyValue) {
        this.metadata[field.name] = '';
        variables[field.name] = 0;
        continue;
      }
      let result = evaluateFormula(field.function, variables);
      //se muestra con coma decimal para ser coherente con la entrada en español
      this.metadata[field.name] = result === null ? '' : result.toFixed(2).replace('.', ',');
      //el resultado alimenta otras fórmulas que lo referencien (se guarda numérico)
      variables[field.name] = result === null ? 0 : result;
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

}
